<template>
  <div>
    <div class="widewrapper main">
        <div class="container">
            <div class="row">
                <div class="col-md-8 blog-main">
                    <div class="row">
                        <!-- 一行开始 -->
                        <div v-for="(item, i) in list" :key="i" class="col-md-6 col-sm-6">
                            <article class=" blog-teaser">
                                <header>
                                    <img style="height:150px;" :src="'https://mztrade99.oss-cn-qingdao.aliyuncs.com/blog/' + item.Cover" alt="">
                                    <h3><a @click="goto(item.Link)">{{item.Title}}</a></h3>
                                    <span class="meta">
                                        {{item.Ctime}}：{{item.Author}}
                                    </span>
                                    <hr>
                                </header>
                                <div class="body">
                                    {{item.Description}}
                                </div>
                                <div class="clearfix">
                                    <a class="btn btn-clean-one" @click="goto(item.Link)">了解</a>
                                </div>
                            </article>
                        </div>
                        <!-- 一行结束 -->                        
                    </div>
                    <div class="paging">
                        <a class='older outside' @click="toFirst()">^</a>&nbsp;
                        <a class='older inside' @click="toPrev()">prev</a>&nbsp;
                        <a class='older'>{{page}}</a>&nbsp;
                        <a class='older inside' @click="toNext()">next</a>&nbsp;
                        <a class='older outside' @click="toLast()">$</a>
                    </div>
                </div>
                <aside class="col-md-4 blog-aside">
                    <navi></navi>
                </aside>   
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import navi from "../components/navi"
export default {
  name: 'List',
  data () {
    return {
        page: 1,
        total: 1,
        category: "",
        timeline: "",
        search: "",
        list: [],
    }
  },
  metaInfo: {
      meta: [
          { name: 'keywords', content: '范祯的博客' },
          { name: 'description', content: '前360资深研发，分享些有趣好玩的东西' }
      ]
  },
  components: {
      navi
  },
  created() {
  },
  mounted(){
    var category = this.$route.query.category;
    if (category != undefined) {
        this.timeline = ''
        this.search = ''
        this.category = category
    }
    var timeline = this.$route.query.timeline;
    if (timeline != undefined) {
        this.category = ''
        this.search = ''
        this.timeline = timeline
    }
    var search = this.$route.query.search;
    if (search != undefined) {
        this.category = ''
        this.timeline = ''
        this.search = search
    }
    var page = this.$route.query.page;
    if (page != undefined) {
        this.page = page
    }
    this.getData()
  },
  methods : {
        getData: function () {
            var that = this
            let params = {
                page : that.page,
                category : that.category,
                timeline : that.timeline,
                search : that.search,
            }
            this.$api.getBlogByPage(params).then((res)=>{
                // 时间戳转换
                var data = res.data.List
                for (var i = 0 ; i < data.length; i++){
                    data[i].Ctime = that.formatDate(data[i].Ctime)
                }
                that.page = res.data.Page
                that.total = res.data.Total
                that.category = res.data.Category
                that.timeline = res.data.Timeline
                that.search = res.data.Search
                that.list = data
            }).catch((res)=>{
            })
        },
        formatDate: function (timestamp) {
            var date = new Date(parseInt(timestamp) * 1000);
            var YY = date.getFullYear() + '-';
            var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
            return YY + MM + DD;
        },
        toFirst: function () {
            this.page = 1
            this.pages()
        },
        toPrev: function () {
            var now = parseInt(this.page)
            this.page = (now - 1) > 1 ? (now - 1) : 1
            this.pages()
        },
        toNext: function (){
            var now = parseInt(this.page)
            this.page = (now + 1) < this.total ? (now + 1) : this.total
            this.pages()
        },
        toLast: function (){
            this.page = this.total
            this.pages()
        },
        goto: function (link){
            this.$router.push({
                path: 'blog/'+link
            })
        },
        pages: function (){
            var params = {}
            if (this.category != '') {
                params.category = this.category
            }
            if (this.timeline != '') {
                params.timeline = this.timeline
            }
            if (this.search != '') {
                params.search = this.search
            }
            params.page = this.page
            this.$router.push({
                name: 'Jump',
                query: params
            })
        }
  }
}
</script>

<style scoped>
.outside {
    color:red;
    font-weight:bold;
    font-size:20px;
}
.inside {
    color:blue;
    font-size:15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/List.vue